export default __webpack_public_path__ + "static/media/dompet-coklat.e0390e50.png";